import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
    return twMerge(clsx(inputs));
}

export const ADMIN_ROLE_IDS = [
    "1407623359386357776",
    "1407623359386357774", 
    "1407623359386357771"
];

export const CATEGORIES = [
    { id: "home", name: "Home", icon: "Home" },
    { id: "relics", name: "Relics", icon: "Gem" },
    { id: "gachas", name: "Gachas", icon: "Sparkles" },
    { id: "upgrades", name: "Upgrades", icon: "ArrowUpCircle" },
    { id: "achievements", name: "Achievements", icon: "Trophy" },
    { id: "tutorials", name: "Tutorials", icon: "BookOpen" },
];

export const isAdmin = (roles) => {
    if (!roles || !Array.isArray(roles)) return false;
    return roles.some(role => ADMIN_ROLE_IDS.includes(role));
};

export const formatDate = (date) => {
    return new Date(date).toLocaleDateString('de-DE', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
    });
};

export const generateId = () => {
    return Math.random().toString(36).substring(2, 15);
};

// Image dimension constraints
export const IMAGE_CONSTRAINTS = {
    maxWidth: 500,
    maxHeight: 500,
    recommendedWidth: 500,
    recommendedHeight: 500,
};

export const validateImageUrl = (url) => {
    if (!url) return true;
    try {
        new URL(url);
        return true;
    } catch {
        return false;
    }
};
